import { custom } from "valibot";
import {
    AppPermissionResource,
    ValidCognitoPermissionGroupsEnum,
} from "./AppPermissions";
import { validateAppPermission } from "./functions";
import type { AppPermissionIdentifier } from "./internal";

export const PermissionEffect = ["allow", "deny"] as const;
export type PermissionEffect = (typeof PermissionEffect)[number];

export const ValidCognitoPermissionGroupsNameMap = {
    [ValidCognitoPermissionGroupsEnum.Admin]: "Administrator",
    [ValidCognitoPermissionGroupsEnum.Manager]: "Production Planner",
    [ValidCognitoPermissionGroupsEnum.Supervisor]: "Supervisor",
    [ValidCognitoPermissionGroupsEnum.Operator]: "Operator",
    // [ValidCognitoPermissionGroupsEnum.Guest]: "Guest",
};

/**
 * Display name for a role, falling back to the raw group name for roles
 * without one (e.g. Guest).
 */
export function getRoleDisplayName(
    role: ValidCognitoPermissionGroupsEnum
): string {
    return (
        ValidCognitoPermissionGroupsNameMap[
            role as keyof typeof ValidCognitoPermissionGroupsNameMap
        ] ?? role
    );
}

// Users should not see roles that are preceding them
export const ValidCognitoPermissionGroupsOrder = [
    ValidCognitoPermissionGroupsEnum.Admin,
    ValidCognitoPermissionGroupsEnum.Manager,
    ValidCognitoPermissionGroupsEnum.Supervisor,
    ValidCognitoPermissionGroupsEnum.Operator,
] as const;

export type AppPermissionResourceWithEffect = {
    [P in keyof AppPermissionResource]: {
        [K in AppPermissionResource[P][number]]: PermissionEffect | null;
    };
};

export type AppPermissionIdentifierWithoutWildcard = Exclude<
    AppPermissionIdentifier,
    `${string | undefined}*${string | undefined}`
>;

export const AppPermissionIdentifierWithEffect =
    custom<AppPermissionIdentifierWithEffect>(
        (value) => typeof value === "string" && validateAppPermission(value)
    );
export type AppPermissionIdentifierWithEffect =
    `${AppPermissionIdentifier}::${PermissionEffect}`;
